import React from 'react';

import './style.scss';

function Spinner() {
  return <span className="spinner" />;
}

export default Spinner;
